import apiClient from './api-client'
import type { OrganizationalUnit } from './ou-service'

export interface UserPreferences {
  default_ou_code: string | null
  default_ou: OrganizationalUnit | null
}

export interface UserPreferencesResponse {
  status: boolean
  data: UserPreferences
  message?: string
}

const userPreferencesService = {
  /**
   * Get current user's preferences
   */
  async getPreferences(): Promise<UserPreferencesResponse> {
    const response = await apiClient.get('/user/preferences')
    return response.data
  },

  /**
   * Update user preferences
   */
  async updatePreferences(preferences: Partial<UserPreferences>): Promise<UserPreferencesResponse> {
    const response = await apiClient.put('/user/preferences', preferences)
    return response.data
  },

  /**
   * Set default OU
   */
  async setDefaultOU(ouCode: string | null): Promise<UserPreferencesResponse> {
    const response = await apiClient.post('/user/preferences/default-ou', {
      default_ou_code: ouCode,
    })
    return response.data
  },

  /**
   * Clear default OU
   */
  async clearDefaultOU(): Promise<{ status: boolean; message: string }> {
    const response = await apiClient.delete('/user/preferences/default-ou')
    return response.data
  },
}

export default userPreferencesService
